<!-- Liste des commentaires-->
<div [class.block-loader]="loader.isLoading$ | async">
	<ng-container>
		<loader-spinner [model]="loader"></loader-spinner>
		<div class="text-libre-comments" *ngFor="let commentaire of commentaires">
			<div class="text-libre-comments-metadata">
				<span class="text-libre-comments-metadata-name">{{ commentaire?.utilisateurCreation?.nomContact }}
				</span>
				<span class="text-libre-comments-metadata-date">
					{{ '- ' + (commentaire?.dateCreation | dateFormat : dateFormatType.DDMMYYYYHH) }}
				</span>
				<ng-template [ngTemplateOutlet]="commentaire.motif == 'messageAvocat' ? sousMotif : motif"
					[ngTemplateOutletContext]="{ commentaire: commentaire }">
				</ng-template>
			</div>
			<div class="text-libre-comments-body">
				<span> {{ commentaire?.commentaire }}</span>
			</div>
			<div class="list-commentaire-document" *ngIf="commentaire?.documents?.length > 0">
				PJ -
				<span *ngFor="let item of commentaire?.documents; index as i">
					<span *ngIf="i > 0">,</span>
					{{ item.fileName }}
				</span>
			</div>
		</div>
	</ng-container>
</div>

<ng-template #motif let-commentaire="commentaire">
	<span class="text-libre-comments-metadata-motif">
		{{ '- ' + ('Commentaire.Motifs.' + firstLetterCapitalize(commentaire.motif) | translate) }}</span>
</ng-template>

<ng-template #sousMotif let-commentaire="commentaire">
	<span class="text-libre-comments-metadata-motif"> {{ '- ' + commentaire?.sousMotif?.libelle }}</span>
</ng-template>